<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M18,.73a2.47,2.47,0,0,1,.74,1.77V13.39H29.5a2.52,2.52,0,0,1,1.77.74,2.56,2.56,0,0,1,0,3.58,2.52,2.52,0,0,1-1.77.74H18.71V29.5A2.47,2.47,0,0,1,18,31.27a2.53,2.53,0,0,1-4.31-1.77v-11H2.5a2.52,2.52,0,0,1-1.77-.74,2.56,2.56,0,0,1,0-3.58,2.52,2.52,0,0,1,1.77-.74H13.66V2.5A2.53,2.53,0,0,1,18,.73Z"
    />
</svg>
